export const anthrazitgrau = {
  hex: '#373F43',
  check: '#fff',
  tip: 'anthrazitgrau (ähnlich RAL 7016)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_anthrazitgrau_ral7016.jpg'),
      alt: 'Schnittkante anthrazitgrau ähnlich RAL 7016'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_anthrazitgrau_ral7016.jpg'),
      alt: 'Saum anthrazitgrau ähnlich RAL 7016'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_anthrazitgrau_ral7016.jpg'),
      alt: 'Hohlsaum anthrazitgrau ähnlich RAL 7016'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_anthrazitgrau_ral7016.jpg'),
      alt: 'Keder anthrazitgrau ähnlich RAL 7016'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_anthrazitgrau_ral7016.jpg'),
      alt: 'Hohlschnitt anthrazitgrau ähnlich RAL 7016'
    }
  },
  code: 'C01',
  id: 1
}

export const beige = {
  hex: '#DFCEA1',
  check: '#fff',
  tip: 'beige (ähnlich RAL 1014)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_beige_ral1014.jpg'),
      alt: 'Schnittkante beige ähnlich RAL 1014'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_beige_ral1014.jpg'),
      alt: 'Saum beige ähnlich RAL 1014'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_beige_ral1014.jpg'),
      alt: 'Hohlsaum beige ähnlich RAL 1014'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_beige_ral1014.jpg'),
      alt: 'Keder beige ähnlich RAL 1014'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_beige_ral1014.jpg'),
      alt: 'Hohlschnitt beige ähnlich RAL 1014'
    }
  },
  code: 'C02',
  id: 2
}

export const hellgrau = {
  hex: '#B9B9AF',
  check: '#fff',
  tip: 'hellgrau (Farb-Nummer 705)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_hellgrau_farbnummer705.jpg'),
      alt: 'Schnittkante hellgrau Farb-Nummer 705'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_hellgrau_farbnummer705.jpg'),
      alt: 'Saum hellgrau Farb-Nummer 705'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_hellgrau_farbnummer705.jpg'),
      alt: 'Hohlsaum hellgrau Farb-Nummer 705'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_hellgrau_farbnummer705.jpg'),
      alt: 'Keder hellgrau Farb-Nummer 705'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_hellgrau_farbnummer705.jpg'),
      alt: 'Hohlschnitt hellgrau Farb-Nummer 705'
    }
  },
  code: 'C03',
  id: 3
}

export const karminrot = {
  hex: '#A1232B',
  check: '#fff',
  tip: 'karminrot (ähnlich RAL 3002)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_karminrot_ral3002.jpg'),
      alt: 'Schnittkante karminrot ähnlich RAL 3002'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_karminrot_ral3002.jpg'),
      alt: 'Saum karminrot ähnlich RAL 3002'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_karminrot_ral3002.jpg'),
      alt: 'Hohlsaum karminrot ähnlich RAL 3002'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_karminrot_ral3002.jpg'),
      alt: 'Keder karminrot ähnlich RAL 3002'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_karminrot_ral3002.jpg'),
      alt: 'Hohlschnitt karminrot ähnlich RAL 3002'
    }
  },
  code: 'C04',
  id: 4
}

export const kobaltblau = {
  hex: '#232D53',
  check: '#fff',
  tip: 'kobaltblau (ähnlich RAL 5013)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_kobaltblau_ral5013.jpg'),
      alt: 'Schnittkante kobaltblau ähnlich RAL 5013'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_kobaltblau_ral5013.jpg'),
      alt: 'Saum kobaltblau ähnlich RAL 5013'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_kobaltblau_ral5013.jpg'),
      alt: 'Hohlsaum kobaltblau ähnlich RAL 5013'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_kobaltblau_ral5013.jpg'),
      alt: 'Keder kobaltblau ähnlich RAL 5013'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_kobaltblau_ral5013.jpg'),
      alt: 'Hohlschnitt kobaltblau ähnlich RAL 5013'
    }
  },
  code: 'C05',
  id: 5
}

export const lichtgrau = {
  hex: '#CBD0CC',
  check: '#fff',
  tip: 'lichtgrau (ähnlich RAL 7035)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_lichtgrau_ral7035.jpg'),
      alt: 'Schnittkante lichtgrau ähnlich RAL 7035'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_lichtgrau_ral7035.jpg'),
      alt: 'Saum lichtgrau ähnlich RAL 7035'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_lichtgrau_ral7035.jpg'),
      alt: 'Hohlsaum lichtgrau ähnlich RAL 7035'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_lichtgrau_ral7035.jpg'),
      alt: 'Keder lichtgrau ähnlich RAL 7035'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_lichtgrau_ral7035.jpg'),
      alt: 'Hohlschnitt lichtgrau ähnlich RAL 7035'
    }
  },
  code: 'C06',
  id: 6
}

export const moosgruen = {
  hex: '#0F4336',
  check: '#fff',
  tip: 'moosgrün (ähnlich RAL 6005)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_moosgruen_ral6005.jpg'),
      alt: 'Schnittkante moosgrün ähnlich RAL 6005'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_moosgruen_ral6005.jpg'),
      alt: 'Saum moosgrün ähnlich RAL 6005'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_moosgruen_ral6005.jpg'),
      alt: 'Hohlsaum moosgrün ähnlich RAL 6005'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_moosgruen_ral6005.jpg'),
      alt: 'Keder moosgrün ähnlich RAL 6005'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_moosgruen_ral6005.jpg'),
      alt: 'Hohlschnitt moosgrün ähnlich RAL 6005'
    }
  },
  code: 'C07',
  id: 7
}

export const oekograu = {
  hex: '#9EA0A1',
  check: '#fff',
  tip: 'ökograu (Restpaste)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_oekograu_restpaste.jpg'),
      alt: 'Schnittkante ökograu Restpaste ohne RAL'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_oekograu_restpaste.jpg'),
      alt: 'Saum ökograu Restpaste ohne RAL'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_oekograu_restpaste.jpg'),
      alt: 'Hohlsaum ökograu Restpaste ohne RAL'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_oekograu_restpaste.jpg'),
      alt: 'Keder ökograu Restpaste ohne RAL'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_oekograu_restpaste.jpg'),
      alt: 'Hohlschnitt ökograu Restpaste ohne RAL'
    }
  },
  code: 'C08',
  id: 8
}

export const opalgruen = {
  hex: '#005D52',
  check: '#fff',
  tip: 'opalgrün (ähnlich RAL 6026)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_opalgruen_ral6026.jpg'),
      alt: 'Schnittkante opalgrün ähnlich RAL 6026'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_opalgruen_ral6026.jpg'),
      alt: 'Saum opalgrün ähnlich RAL 6026'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_opalgruen_ral6026.jpg'),
      alt: 'Hohlsaum opalgrün ähnlich RAL 6026'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_opalgruen_ral6026.jpg'),
      alt: 'Keder opalgrün ähnlich RAL 6026'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_opalgruen_ral6026.jpg'),
      alt: 'Hohlschnitt opalgrün ähnlich RAL 6026'
    }
  },
  code: 'C09',
  id: 9
}

export const reinorange = {
  hex: '#E75B12',
  check: '#fff',
  tip: 'reinorange (ähnlich RAL 2004)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_reinorange_ral2004.jpg'),
      alt: 'Schnittkante reinorange ähnlich RAL 2004'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_reinorange_ral2004.jpg'),
      alt: 'Saum reinorange ähnlich RAL 2004'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_reinorange_ral2004.jpg'),
      alt: 'Hohlsaum reinorange ähnlich RAL 2004'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_reinorange_ral2004.jpg'),
      alt: 'Keder reinorange ähnlich RAL 2004'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_reinorange_ral2004.jpg'),
      alt: 'Hohlschnitt reinorange ähnlich RAL 2004'
    }
  },
  code: 'C10',
  id: 10
}

export const reinweiss = {
  hex: '#FFFFFF',
  check: '#000',
  tip: 'reinweiß (ähnlich RAL 9010)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_reinweiss_ral9010.jpg'),
      alt: 'Schnittkante reinweiß ähnlich RAL 9010'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_reinweiss_ral9010.jpg'),
      alt: 'Saum reinweiß ähnlich RAL 9010'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_reinweiss_ral9010.jpg'),
      alt: 'Hohlsaum reinweiß ähnlich RAL 9010'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_reinweiss_ral9010.jpg'),
      alt: 'Keder reinweiß ähnlich RAL 9010'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_reinweiss_ral9010.jpg'),
      alt: 'Hohlschnitt reinweiß ähnlich RAL 9010'
    }
  },
  code: 'C11',
  id: 11
}

export const signalgelb = {
  hex: '#F7BA0B',
  check: '#fff',
  tip: 'signalgelb (ähnlich RAL 1003)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_signalgelb_ral1003.jpg'),
      alt: 'Schnittkante signalgelb ähnlich RAL 1003'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_signalgelb_ral1003.jpg'),
      alt: 'Saum signalgelb ähnlich RAL 1003'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_signalgelb_ral1003.jpg'),
      alt: 'Hohlsaum signalgelb ähnlich RAL 1003'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_signalgelb_ral1003.jpg'),
      alt: 'Keder signalgelb ähnlich RAL 1003'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_signalgelb_ral1003.jpg'),
      alt: 'Hohlschnitt signalgelb ähnlich RAL 1003'
    }
  },
  code: 'C12',
  id: 12
}

export const tieforange = {
  hex: '#EC7C25',
  check: '#fff',
  tip: 'tieforange (ähnlich RAL 2011)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_tieforange_ral2011.jpg'),
      alt: 'Schnittkante tieforange ähnlich RAL 2011'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_tieforange_ral2011.jpg'),
      alt: 'Saum tieforange ähnlich RAL 2011'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_tieforange_ral2011.jpg'),
      alt: 'Hohlsaum tieforange ähnlich RAL 2011'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_tieforange_ral2011.jpg'),
      alt: 'Keder tieforange ähnlich RAL 2011'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_tieforange_ral2011.jpg'),
      alt: 'Hohlschnitt tieforange ähnlich RAL 2011'
    }
  },
  code: 'C13',
  id: 13
}

export const tiefschwarz = {
  hex: '#0A0A0A',
  check: '#fff',
  tip: 'tiefschwarz (ähnlich RAL 9005)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_tiefschwarz_ral9005.jpg'),
      alt: 'Schnittkante tiefschwarz ähnlich RAL 9005'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_tiefschwarz_ral9005.jpg'),
      alt: 'Saum tiefschwarz ähnlich RAL 9005'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_tiefschwarz_ral9005.jpg'),
      alt: 'Hohlsaum tiefschwarz ähnlich RAL 9005'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_tiefschwarz_ral9005.jpg'),
      alt: 'Keder tiefschwarz ähnlich RAL 9005'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_tiefschwarz_ral9005.jpg'),
      alt: 'Hohlschnitt tiefschwarz ähnlich RAL 9005'
    }
  },
  code: 'C14',
  id: 14
}

export const ultramarinblau = {
  hex: '#2B2C7C',
  check: '#fff',
  tip: 'ultramarinblau (ähnlich RAL 5002)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_ultramarinblau_ral5002.jpg'),
      alt: 'Schnittkante ultramarinblau ähnlich RAL 5002'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_ultramarinblau_ral5002.jpg'),
      alt: 'Saum ultramarinblau ähnlich RAL 5002'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_ultramarinblau_ral5002.jpg'),
      alt: 'Hohlsaum ultramarinblau ähnlich RAL 5002'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_ultramarinblau_ral5002.jpg'),
      alt: 'Keder ultramarinblau ähnlich RAL 5002'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_ultramarinblau_ral5002.jpg'),
      alt: 'Hohlschnitt ultramarinblau ähnlich RAL 5002'
    }
  },
  code: 'C15',
  id: 15
}

export const verkehrsgelb = {
  hex: '#F0CA00',
  check: '#fff',
  tip: 'verkehrsgelb (ähnlich RAL 1023)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_verkehrsgelb_ral1023.jpg'),
      alt: 'Schnittkante verkehrsgelb ähnlich RAL 1023'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_verkehrsgelb_ral1023.jpg'),
      alt: 'Saum verkehrsgelb ähnlich RAL 1023'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_verkehrsgelb_ral1023.jpg'),
      alt: 'Hohlsaum verkehrsgelb ähnlich RAL 1023'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_verkehrsgelb_ral1023.jpg'),
      alt: 'Keder verkehrsgelb ähnlich RAL 1023'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_verkehrsgelb_ral1023.jpg'),
      alt: 'Hohlschnitt verkehrsgelb ähnlich RAL 1023'
    }
  },
  code: 'C16',
  id: 16
}

export const alugrau = {
  hex: '#7C7F7E',
  check: '#fff',
  tip: 'alugrau (ähnlich RAL 7037)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_alugrau_ral7037.jpg'),
      alt: 'Schnittkante alugrau ähnlich RAL 7037'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_alugrau_ral7037.jpg'),
      alt: 'Saum alugrau ähnlich RAL 7037'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_alugrau_ral7037.jpg'),
      alt: 'Hohlsaum alugrau ähnlich RAL 7037'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_alugrau_ral7037.jpg'),
      alt: 'Keder alugrau ähnlich RAL 7037'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_alugrau_ral7037.jpg'),
      alt: 'Hohlschnitt alugrau ähnlich RAL 7037'
    }
  },
  code: 'C17',
  id: 17
}

export const enzianblau = {
  hex: '#13447C',
  check: '#fff',
  tip: 'enzianblau (ähnlich RAL 5010)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_enzianblau_ral5010.jpg'),
      alt: 'Schnittkante enzianblau ähnlich RAL 5010'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_enzianblau_ral5010.jpg'),
      alt: 'Saum enzianblau ähnlich RAL 5010'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_enzianblau_ral5010.jpg'),
      alt: 'Hohlsaum enzianblau ähnlich RAL 5010'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_enzianblau_ral5010.jpg'),
      alt: 'Keder enzianblau ähnlich RAL 5010'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_enzianblau_ral5010.jpg'),
      alt: 'Hohlschnitt enzianblau ähnlich RAL 5010'
    }
  },
  code: 'C18',
  id: 18
}

export const himmelblau = {
  hex: '#2874B2',
  check: '#fff',
  tip: 'himmelblau (ähnlich RAL 5015)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_himmelblau_ral5015.jpg'),
      alt: 'Schnittkante himmelblau ähnlich RAL 5015'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_himmelblau_ral5015.jpg'),
      alt: 'Saum himmelblau ähnlich RAL 5015'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_himmelblau_ral5015.jpg'),
      alt: 'Hohlsaum himmelblau ähnlich RAL 5015'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_himmelblau_ral5015.jpg'),
      alt: 'Keder himmelblau ähnlich RAL 5015'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_himmelblau_ral5015.jpg'),
      alt: 'Hohlschnitt himmelblau ähnlich RAL 5015'
    }
  },
  code: 'C19',
  id: 19
}

export const candyWeiss = {
  hex: '#f9f9f1',
  check: '#000',
  tip: 'weiß',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_weiss_candy.jpg'),
      alt: 'Schnittkante weiß transluzent'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_weiss_candy.jpg'),
      alt: 'Saum weiß transluzent'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_weiss_candy.jpg'),
      alt: 'Hohlsaum weiß transluzent'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_weiss_candy.jpg'),
      alt: 'Keder weiß transluzent'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_weiss_candy.jpg'),
      alt: 'Hohlschnitt weiß transluzent'
    }
  },
  code: 'C20',
  id: 20
}

export const candyGelb = {
  hex: '#f0efc1',
  check: '#fff',
  tip: 'gelb',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_gelb_candy.jpg'),
      alt: 'Schnittkante gelb transluzent'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_gelb_candy.jpg'),
      alt: 'Saum gelb transluzent'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_gelb_candy.jpg'),
      alt: 'Hohlsaum gelb transluzent'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_gelb_candy.jpg'),
      alt: 'Keder gelb transluzent'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_gelb_candy.jpg'),
      alt: 'Hohlschnitt gelb transluzent'
    }
  },
  code: 'C21',
  id: 21
}

export const candyRot = {
  hex: '#e0c3b3',
  check: '#fff',
  tip: 'rot',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_rot_candy.jpg'),
      alt: 'Schnittkante rot transluzent'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_rot_candy.jpg'),
      alt: 'Saum rot transluzent'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_rot_candy.jpg'),
      alt: 'Hohlsaum rot transluzent'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_rot_candy.jpg'),
      alt: 'Keder rot transluzent'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_rot_candy.jpg'),
      alt: 'Hohlschnitt rot transluzent'
    }
  },
  code: 'C22',
  id: 22
}

export const candyBlau = {
  hex: '#becde0',
  check: '#fff',
  tip: 'blau',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_blau_candy.jpg'),
      alt: 'Schnittkante blau transluzent'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_blau_candy.jpg'),
      alt: 'Saum blau transluzent'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_blau_candy.jpg'),
      alt: 'Hohlsaum blau transluzent'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_blau_candy.jpg'),
      alt: 'Keder blau transluzent'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_blau_candy.jpg'),
      alt: 'Hohlschnitt blau transluzent'
    }
  },
  code: 'C23',
  id: 23
}

export const candyGruen = {
  hex: '#d3f0e2',
  check: '#fff',
  tip: 'grün',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_gruen_candy.jpg'),
      alt: 'Schnittkante grün transluzent'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_gruen_candy.jpg'),
      alt: 'Saum grün transluzent'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_gruen_candy.jpg'),
      alt: 'Hohlsaum grün transluzent'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_gruen_candy.jpg'),
      alt: 'Keder grün transluzent'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_gruen_candy.jpg'),
      alt: 'Hohlschnitt grün transluzent'
    }
  },
  code: 'C24',
  id: 24
}

export const candyGrau = {
  hex: '#b1aaa2',
  check: '#fff',
  tip: 'grau',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_grau_candy.jpg'),
      alt: 'Schnittkante grau transluzent'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_grau_candy.jpg'),
      alt: 'Saum grau transluzent'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_grau_candy.jpg'),
      alt: 'Hohlsaum grau transluzent'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_grau_candy.jpg'),
      alt: 'Keder grau transluzent'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_grau_candy.jpg'),
      alt: 'Hohlschnitt grau transluzent'
    }
  },
  code: 'C25',
  id: 25
}

export const steingrau = {
  hex: '#b9c1c3',
  check: '#fff',
  tip: 'steingrau (Farb-Nummer 712)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_steingrau_ohneral.jpg'),
      alt: 'Schnittkante steingrau (Farb-Nummer 712)'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_steingrau_ohneral.jpg'),
      alt: 'Saum steingrau (Farb-Nummer 712)'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_steingrau_ohneral.jpg'),
      alt: 'Hohlsaum steingrau (Farb-Nummer 712)'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_steingrau_ohneral.jpg'),
      alt: 'Keder steingrau (Farb-Nummer 712)'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_steingrau_ohneral.jpg'),
      alt: 'Hohlschnitt steingrau (Farb-Nummer 712)'
    }
  },
  code: 'C26',
  id: 26
}

export const weissTransluzent = {
  hex: '#f9f9f1',
  check: '#000',
  tip: 'weiß-transluzent',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_weiss-transluzent.jpg'),
      alt: 'Schnittkante weiß transluzent'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_weiss-transluzent.jpg'),
      alt: 'Saum weiß transluzent'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_weiss-transluzent.jpg'),
      alt: 'Hohlsaum weiß transluzent'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_weiss-transluzent.jpg'),
      alt: 'Keder weiß transluzent'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_weiss-transluzent.jpg'),
      alt: 'Hohlschnitt weiß transluzent'
    }
  },
  code: 'C27',
  id: 27
}

export const brillantgelb = {
  hex: '#fbd326',
  check: '#fff',
  tip: 'brillantgelb (Farb-Nummer 119)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_brillantgelb_farbnr119.jpg'),
      alt: 'Schnittkante brillantgelb Farb-Nummer 119'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_brillantgelb_farbnr119.jpg'),
      alt: 'Saum brillantgelb Farb-Nummer 119'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_brillantgelb_farbnr119.jpg'),
      alt: 'Hohlsaum brillantgelb Farb-Nummer 119'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_brillantgelb_farbnr119.jpg'),
      alt: 'Keder brillantgelb Farb-Nummer 119'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_brillantgelb_farbnr119.jpg'),
      alt: 'Hohlschnitt brillantgelb Farb-Nummer 119'
    }
  },
  code: 'C28',
  id: 28
}

export const kieferngruen = {
  hex: '#2D5546',
  check: '#fff',
  tip: 'kieferngrün (ähnlich RAL 6028)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_kieferngruen_ral6028.jpg'),
      alt: 'Schnittkante kieferngrün ähnlich RAL 6028'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_kieferngruen_ral6028.jpg'),
      alt: 'Saum kieferngrün ähnlich RAL 6028'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_kieferngruen_ral6028.jpg'),
      alt: 'Hohlsaum kieferngrün ähnlich RAL 6028'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_kieferngruen_ral6028.jpg'),
      alt: 'Keder kieferngrün ähnlich RAL 6028'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_kieferngruen_ral6028.jpg'),
      alt: 'Hohlschnitt kieferngrün ähnlich RAL 6028'
    }
  },
  code: 'C29',
  id: 29
}

export const koenigsblau = {
  hex: '#17357e',
  check: '#fff',
  tip: 'königsblau (Farb-Nummer 543)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_koenigsblau_farbnr543.jpg'),
      alt: 'Schnittkante königsblau Farb-Nummer 543'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_koenigsblau_farbnr543.jpg'),
      alt: 'Saum königsblau Farb-Nummer 543'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_koenigsblau_farbnr543.jpg'),
      alt: 'Hohlsaum königsblau Farb-Nummer 543'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_koenigsblau_farbnr543.jpg'),
      alt: 'Keder königsblau Farb-Nummer 543'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_koenigsblau_farbnr543.jpg'),
      alt: 'Hohlschnitt königsblau Farb-Nummer 543'
    }
  },
  code: 'C30',
  id: 30
}

export const zinkgelb = {
  hex: '#F3E03B',
  check: '#fff',
  tip: 'zinkgelb (ähnlich RAL 1018)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_zinkgelb_ral1018.jpg'),
      alt: 'Schnittkante zinkgelb ähnlich RAL 1018'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_zinkgelb_ral1018.jpg'),
      alt: 'Saum zinkgelb ähnlich RAL 1018'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_zinkgelb_ral1018.jpg'),
      alt: 'Hohlsaum zinkgelb ähnlich RAL 1018'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_zinkgelb_ral1018.jpg'),
      alt: 'Keder zinkgelb ähnlich RAL 1018'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_zinkgelb_ral1018.jpg'),
      alt: 'Hohlschnitt zinkgelb ähnlich RAL 1018'
    }
  },
  code: 'C31',
  id: 31
}

export const feuerrot = {
  hex: '#AB2524',
  check: '#fff',
  tip: 'feuerrot (ähnlich RAL 3000)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_feuerrot_ral3000.jpg'),
      alt: 'Schnittkante feuerrot ähnlich RAL 3000'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_feuerrot_ral3000.jpg'),
      alt: 'Saum feuerrot ähnlich RAL 3000'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_feuerrot_ral3000.jpg'),
      alt: 'Hohlsaum feuerrot ähnlich RAL 3000'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_feuerrot_ral3000.jpg'),
      alt: 'Keder feuerrot ähnlich RAL 3000'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_feuerrot_ral3000.jpg'),
      alt: 'Hohlschnitt feuerrot ähnlich RAL 3000'
    }
  },
  code: 'C32',
  id: 32
}

export const hellelfenbein = {
  hex: '#EADEBD',
  check: '#fff',
  tip: 'hellelfenbein (ähnlich RAL 1015)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_hellelfenbein_ral1015.jpg'),
      alt: 'Schnittkante hellelfenbein ähnlich RAL 1015'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_hellelfenbein_ral1015.jpg'),
      alt: 'Saum hellelfenbein ähnlich RAL 1015'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_hellelfenbein_ral1015.jpg'),
      alt: 'Hohlsaum hellelfenbein ähnlich RAL 1015'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_hellelfenbein_ral1015.jpg'),
      alt: 'Keder hellelfenbein ähnlich RAL 1015'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_hellelfenbein_ral1015.jpg'),
      alt: 'Hohlschnitt hellelfenbein ähnlich RAL 1015'
    }
  },
  code: 'C33',
  id: 33
}

export const orange = {
  hex: '#F3752C',
  check: '#fff',
  tip: 'orange (ähnlich RAL 2008)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_orange_ral2008.jpg'),
      alt: 'Schnittkante orange ähnlich RAL 2008'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_orange_ral2008.jpg'),
      alt: 'Saum orange ähnlich RAL 2008'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_orange_ral2008.jpg'),
      alt: 'Hohlsaum orange ähnlich RAL 2008'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_orange_ral2008.jpg'),
      alt: 'Keder orange ähnlich RAL 2008'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_orange_ral2008.jpg'),
      alt: 'Hohlschnitt orange ähnlich RAL 2008'
    }
  },
  code: 'C34',
  id: 34
}

export const lichtblau = {
  hex: '#3481B8',
  check: '#fff',
  tip: 'lichtblau (ähnlich RAL 5012)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_lichtblau_ral5012.jpg'),
      alt: 'Schnittkante lichtblau ähnlich RAL 5012'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_lichtblau_ral5012.jpg'),
      alt: 'Saum lichtblau ähnlich RAL 5012'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_lichtblau_ral5012.jpg'),
      alt: 'Hohlsaum lichtblau ähnlich RAL 5012'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_lichtblau_ral5012.jpg'),
      alt: 'Keder lichtblau ähnlich RAL 5012'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_lichtblau_ral5012.jpg'),
      alt: 'Hohlschnitt lichtblau ähnlich RAL 5012'
    }
  },
  code: 'C35',
  id: 35
}

export const silbergrau = {
  hex: '#A5A5A5',
  check: '#fff',
  tip: 'silbergrau (ähnlich RAL 9006)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_silbergrau_ral9006.jpg'),
      alt: 'Schnittkante silbergrau ähnlich RAL 9006'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_silbergrau_ral9006.jpg'),
      alt: 'Saum silbergrau ähnlich RAL 9006'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_silbergrau_ral9006.jpg'),
      alt: 'Hohlsaum silbergrau ähnlich RAL 9006'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_silbergrau_ral9006.jpg'),
      alt: 'Keder silbergrau ähnlich RAL 9006'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_silbergrau_ral9006.jpg'),
      alt: 'Hohlschnitt silbergrau ähnlich RAL 9006'
    }
  },
  code: 'C36',
  id: 36
}

export const beigeOhneRal = {
  hex: '#d6c69e',
  check: '#fff',
  tip: 'beige (ohne RAL)',
  img: {
    schnittkante: {
      src: require('../../../../../assets/img/rand/schnittkante_beige_ohneral.jpg'),
      alt: 'Schnittkante beige ohne RAL'
    },
    saum: {
      src: require('../../../../../assets/img/rand/saum_beige_ohneral.jpg'),
      alt: 'Saum beige ohne RAL'
    },
    hohlsaum: {
      src: require('../../../../../assets/img/rand/hohlsaum_beige_ohneral.jpg'),
      alt: 'Hohlsaum beige ohne RAL'
    },
    keder: {
      src: require('../../../../../assets/img/rand/keder_beige_ohneral.jpg'),
      alt: 'Keder beige ohne RAL'
    },
    hohlschnitt: {
      src: require('../../../../../assets/img/rand/hohlschnitt_beige_ohneral.jpg'),
      alt: 'Hohlschnitt beige ohne RAL'
    }
  },
  code: 'C37',
  id: 37
}
